import { useContext } from 'react';

import { InstallPwaContext } from 'src/Providers/InstallPwaProvider';

export const useInstallPwa = () => useContext(InstallPwaContext);
